import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * 定义 RelateTitle 组件
 */
class RelateTitle extends PureComponent {
    static propTypes = { content: PropTypes.string };

    render() {
        const { content } = this.props;

        return <h2 className={styles.relate_title}>{content}</h2>;
    }
}

export default errorBoundary(RelateTitle);
